import { useMemo } from 'react';
import { useInteractionContext } from '../../context';

const useFilterActive = (items: any) => {
  const { isHovered, isSelected } = useInteractionContext();
  return useMemo(
    () => items.filter((d: any) => isHovered(d.id) || isSelected(d.id)),
    [items, isHovered, isSelected],
  );
};

export default useFilterActive;
